export const initFeaturesToggleSlider = () => {
  const slider = document.querySelector(".features-toggle-slider");
  if (!slider) return;

  const navItems = slider.querySelectorAll(".features-toggle-slider__nav-item");
  const items = slider.querySelectorAll(".fts-item");
  const prevBtn = slider.querySelector(".fts-arrow--prev");
  const nextBtn = slider.querySelector(".fts-arrow--next");

  let current = 0;
  const total = items.length;
  let isAnimating = false;

  const show = (next) => {
    if (next === current || isAnimating) return;
    isAnimating = true;

    navItems[current]?.classList.remove("active");
    navItems[next]?.classList.add("active");

    items[current]?.classList.remove("active");

    requestAnimationFrame(() => {
      items[next]?.classList.add("active");
      current = next;

      setTimeout(() => {
        isAnimating = false;
      }, 450);
    });
  };

  items.forEach((el, i) => {
    el.classList.toggle("is-active", i === 0);
  });

  navItems.forEach((nav, i) => {
    nav.addEventListener("click", () => show(i));
  });

  prevBtn?.addEventListener("click", () => {
    show((current - 1 + total) % total);
  });

  nextBtn?.addEventListener("click", () => {
    show((current + 1) % total);
  });

  let startX = 0;
  let deltaX = 0;

  slider.addEventListener(
    "touchstart",
    (e) => {
      startX = e.touches[0].clientX;
    },
    { passive: true }
  );

  slider.addEventListener(
    "touchmove",
    (e) => {
      deltaX = e.touches[0].clientX - startX;
    },
    { passive: true }
  );

  slider.addEventListener("touchend", () => {
    if (Math.abs(deltaX) < 50) return;

    if (deltaX > 0) {
      show((current - 1 + total) % total);
    } else {
      show((current + 1) % total);
    }

    startX = 0;
    deltaX = 0;
  });
};
